import appSettings from "../../settings/appSettings";
import { Say } from "../../languages";
import NonBreakingSpace from "./NonBreakingSpace";
import { PRIVACY_NOTICE_URL, SMS_TERMS_URL, stripSmsLegalLinks } from "./smsConsentCopy";

type SmsOptInProps = {
  checked: boolean;
  visible?: boolean;
  /** Chosen renders the SMS Terms / Privacy Notice links separately, under the
   * reCAPTCHA disclaimer, so its label carries the consent sentence only. */
  hideLegalLinks?: boolean;
  onToggle: (enabled: boolean) => void;
};

export function SmsOptIn(props: SmsOptInProps) {
  const { checked, visible, hideLegalLinks = false, onToggle } = props;
  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onToggle(e.target.checked);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="form-group sms-optin-container">
      <div className="form-check">
        <label className="form-check-label" htmlFor="smsOptIn">
          <input
            type="checkbox"
            className="form-check-input"
            id="smsOptIn"
            checked={checked}
            onChange={onChange}
          />
          <NonBreakingSpace size={2} />
          <Say
            phrase="payment_step.sms_opt_in"
            dynamicValue={appSettings.smsOptinMessage}
            mutator={(value) => {
              const resolved = value
                .replace("{{smsTermsUrl}}", SMS_TERMS_URL)
                .replace("{{privacyNoticeUrl}}", PRIVACY_NOTICE_URL);
              return hideLegalLinks ? stripSmsLegalLinks(resolved) : resolved;
            }}
            renderHtml={true}
          />
        </label>
      </div>
    </div>
  );
}

export default SmsOptIn;
